module.exports = __webpack_public_path__ + "static/media/terma.97eeec22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/terma.png
// module id = 966
// module chunks = 0